import script from "./mindweb-survey.vue?vue&type=script&setup=true&lang=js"
export * from "./mindweb-survey.vue?vue&type=script&setup=true&lang=js"

import "./mindweb-survey.vue?vue&type=style&index=0&id=582e3c2e&lang=scss"

const __exports__ = script;

export default __exports__